import Cookies from 'js-cookie'
import { Auth0Client } from '@auth0/auth0-spa-js'
import { fbLoginCookie, userSessionCookie } from 'src/constants/auth.constants'
import { appConfig } from 'src/config/app.config'
import { UserProfile } from 'src/types/auth.types'
import { message } from 'antd'
import env from '../constants/auth.constants'
import SegmentAnalytics from 'src/SegmentAnalytics'

export const getBearerToken = () => {
    try {
        return `Bearer ${JSON.parse(Cookies.get(userSessionCookie) || '').token}`
    } catch (e) {
        message.error('Access is restricted. Kindly contact the relevant team for assistance.')
    }
    return null
}

export const deleteLocalSession = () => {
    Cookies.remove(userSessionCookie)
    Cookies.remove(fbLoginCookie)
}

export const logoutUser = async (redirect: string) => {
    SegmentAnalytics.sendTrackEvent('EE_LogoutCTA_Clicked', {})
    deleteLocalSession()
    const authClient = getAuth0Client()
    await authClient.logout({
        logoutParams: {
            returnTo: redirect
                ? `${appConfig.jarvisBaseUrl}?redirect_uri=${encodeURIComponent(redirect)}`
                : appConfig.jarvisBaseUrl,
        },
    })
}

const getAuth0Client = () => {
    return new Auth0Client({
        domain: appConfig.sso.domain,
        clientId: appConfig.sso.clientId,
    })
}

export const redirectToApplication = (urlToRedirectTo: string) => {
    const url = new URL(urlToRedirectTo)
    if (url.host.endsWith('playment.io')) {
        window.location.replace(urlToRedirectTo)
        return
    }

    return
}

const getHashQueryParams = (url: string) => {
    const [, query] = url.split('#')[1].split('?')
    const params = Object.fromEntries(new URLSearchParams(query))
    return params
}

export const getRedirectUri = () => {
    const currentUrl = window.location.href
    if (currentUrl.includes('redirect_uri')) {
        const params = getHashQueryParams(currentUrl)
        return params['redirect_uri']
    }
    return window.location.href
}

const getAuthorizeOptions = () => {
    return {
        authorizationParams: {
            heimdall: [env.DEVELOPMENT, env.TESTING].includes(process.env.NODE_ENV!)
                ? appConfig.heimdallBaseUrl
                : '',
            redirect_uri: getRedirectUri(),
        },
    }
}

export const checkForUserSession = (): Promise<UserProfile> => {
    const authClient = getAuth0Client()
    const options = getAuthorizeOptions()
    const promise = new Promise<UserProfile>((resolve, reject) => {
        authClient
            .getTokenSilently({ ...options, detailedResponse: true })
            .then(() => {
                authClient
                    .getIdTokenClaims()
                    .then(profile => {
                        if (profile) {
                            resolve({
                                ...profile[appConfig.sso.customClaims],
                                email: profile?.email,
                            })
                        } else
                            reject(
                                new Error(
                                    'Something went wrong. Please contact technical support and check your system time.'
                                )
                            )
                    })
                    .catch(err => {
                        reject(err)
                    })
            })
            .catch(err => {
                console.error('GetTokenSilently error: ', err)
                if (err.message === 'Login required') {
                    reject(new Error('login_required'))
                } else if (err.message.includes('Expiration Time (exp) claim error')) {
                    reject(
                        new Error("Incorrect time error. Please check your system's time and date.")
                    )
                } else if (err.message.includes('Invalid state')) {
                    reject(new Error('Invalid state'))
                } else {
                    reject(
                        new Error(
                            'There was an error. Please try again or contact technical support if the issue persists'
                        )
                    )
                }
            })
    })

    return promise
}
